import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/visit-type";

export const pagingVisitType = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getVisitTypeById = (visitTypeId) => axios.get(API_PATH + "/getbyid/" + visitTypeId);

export const saveOrUpdateVisitType = visitType => axios.post(API_PATH + "/save", visitType);

export const deleteVisitType = visitTypeId => axios.delete(API_PATH + '/mark-delete/' + visitTypeId);
